import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import Settings_nav from "./Settings_nav";

const Sms_notification = () => {
  return (
    <div>
      <Header>
        <div className="content">
          <div class="mob_nav">
            <div class=" d-flex justify-content-start ">
              <a href="javascript:window.history.back();" class="">
                <i class="bi bi-arrow-left"></i>
              </a>
              <h2>SMS Notification</h2>
            </div>
          </div>

          <div class="row justify-content-between">
            <div class="col-12 col-md-4 desk_nav">
              <div class="d-flex">
                <a href="javascript:window.history.back();" class="back_btn">
                  <i class="bi bi-arrow-90deg-left"></i>
                </a>
                <h2>SMS Notification</h2>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-3 left_sub_menu_bx mb_display_none">
              {/* <?php include 'settings_nav.php';?> */}
              <Settings_nav />
            </div>
            <div class="col-12 col-md-9">
              <div class="card border-0 shadow-sm">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4 mb-3">
                      <label for="" class="form-label">
                        SMS Notification <span class="text-danger">*</span>
                      </label>
                      <div class="form-check form-switch  mb-2">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckChecked"
                          checked=""
                        />
                        <label
                          class="form-check-label"
                          for="flexSwitchCheckChecked"
                        >
                          On/Off
                        </label>
                      </div>
                    </div>

                    <div class="col-12 col-md mb-3">
                      <div class="alert alert-primary">
                        <strong>912345678</strong> is your registered address to
                        receive notifications.
                      </div>
                    </div>

                    <div class="col-12 col-md-12 mb-3">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Notification Type</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Booking Confirmation</td>
                            <td>
                              <div class="form-check form-switch  mb-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  checked=""
                                />
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Pickup Completed</td>
                            <td>
                              <div class="form-check form-switch  mb-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  checked=""
                                />
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>Out For Delivery</td>
                            <td>
                              <div class="form-check form-switch  mb-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  checked=""
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>Delivered</td>
                            <td>
                              <div class="form-check form-switch  mb-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  checked=""
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>NDR</td>
                            <td>
                              <div class="form-check form-switch  mb-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  checked=""
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>RTO</td>
                            <td>
                              <div class="form-check form-switch  mb-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  checked=""
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <a href="#" class="btn btn-primary">
                    Update
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Sms_notification;
